// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2qfoL","list":"styles_list__15u1n"};